import React, { useState } from 'react';
import { Box, Container, Grid, Typography, Button, Card, CardContent, CardActions } from '@mui/material';
import energyBoost from '../../assets/photoshow2.jpg';
import proAge from '../../assets/oily.jpg';
import hydraGlow from '../../assets/hydra1.png';
import hyaluMinerals from '../../assets/hyalu.jpg';
import arrow from '../../assets/ArrowLarge_Black.svg';
import arrowActive from '../../assets/ArrowSmall_Active.svg';
import { useNavigate } from 'react-router-dom';

export const Page4: React.FC = () => {
    const [activeProduct, setActiveProduct] = useState<number>(1);

    const handleCardClick = (id: number) => {
        setActiveProduct(id);
    };

    const getActiveImage = () => {
        switch (activeProduct) {
            case 1:
                return energyBoost;
            case 2:
                return proAge;
            case 3:
                return hydraGlow;
            case 4:
                return hyaluMinerals;
            default:
                return energyBoost;
        }
    };

    const getBackgroundColor = () => {
        switch (activeProduct) {
            case 1: // ENERGY BOOST - Orange/Yellow
                return 'rgba(255, 245, 230, 1)'; // Warm orange/peach tint
            case 2: // PRO AGE EXPERT - Purple
                return 'rgba(245, 240, 255, 1)'; // Soft purple/lavender tint
            case 3: // HYDRA GLOW - Light Blue
                return 'rgba(230, 245, 255, 1)'; // Light blue/sky tint
            case 4: // HYALU MINERALS - Teal/Green
                return 'rgba(230, 250, 245, 1)'; // Soft teal/mint tint
            default:
                return 'rgba(255, 250, 244, 1)'; // Default beige
        }
    };

    const navigate = useNavigate();

    return (
        <Container maxWidth={false} sx={{ paddingTop: '50px', paddingBottom: '50px', backgroundColor: getBackgroundColor(), transition: 'background-color 0.5s ease' }}>
            <Grid container spacing={4} alignItems="stretch">
                <Grid item xs={12} md={5} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'ClaireMurphy',
                            fontSize: {
                                xs: '20px',
                                sm: '30px',
                                md: '40px',
                            },
                            fontWeight: 400,
                            textAlign: 'left',
                            lineHeight: '26.1px',
                            color: 'rgba(61, 61, 61, 1)',
                            marginBottom: '20px',
                        }}
                    >
                        BIELENDA SUPREMELAB
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Quicksand, sans-serif',
                            fontSize: '18px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            textAlign: 'left',
                            color: 'rgba(136, 136, 136, 1)',
                            marginBottom: '40px',
                            marginTop: '10px',
                        }}
                    >
                        Discover our professional-grade serums designed to address your specific skincare concerns. Each formula is expertly crafted with advanced ingredients for visible results.
                    </Typography>
                    {[
                        {
                            id: 1,
                            title: 'ENERGY BOOST',
                            subtitle: 'Brightening Serum with 4% Ultra-Stable Vitamin C',
                            description: 'Helps to reduce discoloration, lightens the skin, uniforms the coloring, and has a strong antioxidant effect for a radiant, even complexion.',
                        },
                        {
                            id: 2,
                            title: 'PRO AGE EXPERT',
                            subtitle: 'Anti-Wrinkle Serum with Peptide Complex',
                            description: 'Peptides act anti-wrinkle, restore firmness and elasticity,nourish and moisturize, smooth and reduce visible signs of aging.',
                        },
                        {
                            id: 3,
                            title: 'HYDRA GLOW',
                            subtitle: 'Soothing and Moisturizing Elixir',
                            description: 'Intensely soothes and deeply hydrates with 5% Snail Slime Extract, Polyglutamic Acid, and Beta Glucan. Has anti-inflammatory effect, restores skin comfort, and provides the Crystal Skin effect with a light oil-free formula.',
                        },
                        {
                            id: 4,
                            title: 'HYALU MINERALS',
                            subtitle: 'Smoothing Hydro-Serum with Hyaluronic Acid 2%',
                            description: 'Strongly hydrates, strengthens the skin, smooths, supports regeneration processes, has anti-wrinkle properties that reduce signs of aging, and improves overall skin condition and appearance.',
                        },
                    ].map((product) => (
                        <Card
                            key={product.id}
                            onClick={() => handleCardClick(product.id)}
                            sx={{
                                mb: 2,
                                p: 2,
                                borderRadius: '16px',
                                backgroundColor: activeProduct === product.id ? '#FFFFFF' : 'rgba(255, 255, 255, 0.5)',
                                boxShadow: activeProduct === product.id ? '0px 4px 20px rgba(0, 0, 0, 0.1)' : 'none',
                                border: activeProduct === product.id ? '1px solid rgba(0, 48, 135, 0.3)' : '1px solid rgba(0, 48, 135, 0.1)',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                                    cursor: 'pointer',
                                },
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '24px',
                                        fontWeight: 500,
                                        lineHeight: '30px',
                                        textAlign: 'left',
                                        color: 'rgba(61, 61, 61, 1)',
                                        mb: 0.5,
                                    }}
                                >
                                    {product.title}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '18px',
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                        mb: 1,
                                    }}
                                >
                                    {product.subtitle}
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'Quicksand, sans-serif',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '18px',
                                        textAlign: 'left',
                                        color: 'rgba(136, 136, 136, 1)',
                                    }}
                                >
                                    {product.description}
                                </Typography>
                            </CardContent>
                            <CardActions sx={{
                                display: {
                                    xs: 'none',
                                    md: 'flex'
                                }
                            }}>
                                <Box
                                    component="img"
                                    src={activeProduct === product.id ? arrowActive : arrow}
                                    alt="Explore"
                                    sx={{
                                        width: '55px',
                                        height: '55px',
                                    }}
                                />
                            </CardActions>
                        </Card>
                    ))}

                </Grid>
                <Grid item xs={12} md={7} sx={{
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }, alignItems: 'center'
                }}>
                    <Box
                        component="img"
                        src={getActiveImage()}
                        alt="Skincare Product"
                        sx={{
                            width: '100%',
                            height: {
                                xs: '300px',
                                sm: '400px',
                                md: '500px',
                                lg: '900px',
                            },
                            borderRadius: '36px',
                            objectFit: 'cover',
                            objectPosition: 'center',
                        }}
                    />
                </Grid>
            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 4,
                }}
            >
                <Button
                    onClick={() => {
                        navigate('/product');
                    }}
                    sx={{
                        fontFamily: 'Quicksand, sans-serif',
                        fontSize: '18px',
                        fontWeight: 600,
                        lineHeight: '20px',
                        letterSpacing: '0.1em',
                        color: 'rgba(0, 48, 135, 1)',
                        '&:hover': {
                            textDecoration: 'underline',
                        },
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    SHOP ALL
                    <Box
                        component="img"
                        src={arrow}
                        alt="Explore"
                        sx={{
                            width: '55px',
                            height: '55px',
                            marginLeft: '10px'
                        }}
                    />
                </Button>
            </Box>
        </Container>
    );
};
